import config from '../config';
import router from '../router';
import { deleteAccessToken, setAccessToken } from '../utils/tokens';
import {
  GET_APPS,
  GET_APP_USERS,
  UPDATE_APPS,
  UPDATE_APP_USERS,
  REMOVE_ROLES,
  ADD_ROLES,
  FIND_USERS,
  UPDATE_FOUND_USERS,
  ADD_USER_TO_APP,
  REMOVE_USER_FROM_APP,
  REMOVE_FOUND_USER,
  LOGOUT,
  LOGIN,
  SET_ADMIN_DATA,
  SET_USER_RT_ACTION,
  SET_USER_RT_MUTATION,
} from '../constants';
import apiService from '../api/odin-api';

export default {
  async [GET_APPS](store) {
    const resp = await apiService.getApps();

    if (resp.data.success) {
      const apps = resp.data.data;
      store.commit(UPDATE_APPS, apps);

      const appNames = apps.map(app => app.name);
      appNames.forEach(appName => store.dispatch(GET_APP_USERS, appName));
    } else {
      throw new Error(resp);
    }
  },

  async [GET_APP_USERS](store, payload) {
    const resp = await apiService.getAppUsers(payload);

    if (resp.data.success) {
      const users = resp.data.data;
      store.commit(UPDATE_APP_USERS, {
        appName: payload,
        users,
      });
    }
  },

  async [REMOVE_ROLES](store, { sub, appName, roles }) {
    await apiService.removeRoles(sub, appName, roles);

    store.commit(
      REMOVE_ROLES,
      {
        sub,
        appName,
        roles,
      },
    );
  },

  async [ADD_ROLES](store, { sub, roles, appName }) {
    await apiService.addRoles(sub, appName, roles);

    store.commit(ADD_ROLES, { sub, roles, appName });
  },

  async [FIND_USERS](store, { input, appName }) {
    const resp = await apiService.findUsers(input);

    let foundUsers;
    if (resp.data.data) {
      foundUsers = resp.data.data;
    } else {
      foundUsers = [];
    }

    store.commit(UPDATE_FOUND_USERS, {
      foundUsers,
      appName,
    });
  },

  [ADD_USER_TO_APP](store, { user, appName }) {
    store.commit(ADD_USER_TO_APP, { user, appName });
  },

  [REMOVE_USER_FROM_APP](store, { userId, appName, roles }) {
    store.commit(REMOVE_USER_FROM_APP, { userId, appName });

    // если у пользователя есть роли в приложении, то удаляем
    if (roles.length) {
      store.dispatch(REMOVE_ROLES, { sub: userId, appName, roles });
    }
  },

  [REMOVE_FOUND_USER](store, { userId, appName }) {
    store.commit(REMOVE_FOUND_USER, { userId, appName });
  },

  [SET_USER_RT_ACTION]({ commit }, isSend) {
    commit(SET_USER_RT_MUTATION, isSend);
  },

  async [LOGIN](store, { token }) {
    setAccessToken(config.cookieName, token);

    const response = await apiService.logIn(token);

    const user = response.data.data;
    const { display_name: displayName, email } = user;
    const alertContent = `Нет необходимых прав у пользователя ${displayName} ${email || ''}, попробуйте войти через другой аккаунт.`;

    if (user.roles && typeof user.roles !== 'undefined') {
      const isAdminAuth = user.roles.filter(role => role.application_name === 'auth');

      if (isAdminAuth.length) {
        store.commit(SET_ADMIN_DATA, { user });
        // ! закомментировать для показа авторизации локально
        router.push({ path: 'projects' });
      } else {
        alert(alertContent);
        store.dispatch(LOGOUT);
      }
    } else {
      alert(alertContent);
      store.dispatch(LOGOUT);
    }
  },

  async [LOGOUT]() {
    try {
      await apiService.logout();
      deleteAccessToken(config.cookieName);
      router.push({ path: '/auth' });
    } catch (err) {
      console.error(err);
      deleteAccessToken(config.cookieName);
      router.push({ path: '/auth' });
    }
  },
};



// WEBPACK FOOTER //
// ./src/store/actions.js